import { type Maybe } from "@oefr/utils/types"
import { type ElectricityProviderCalendar } from "@/scalars/electricityProviderCalendar"
import { ProviderCalendarId } from "@/scalars/providerCalendarId"

function isValidProviderCalendarId(
    providerCalendarId: string
): providerCalendarId is ProviderCalendarId {
    return Object.values(ProviderCalendarId).includes(providerCalendarId)
}

function isValidElectricityProviderCalendarId(
    providerCalendarId: string
): providerCalendarId is ElectricityProviderCalendar {
    return ["ALL_DAY", "PEAK_OFF_PEAK"].includes(providerCalendarId)
}

const providerCalendarIdMapping = {
    [ProviderCalendarId.BASE]: "ALL_DAY",
    [ProviderCalendarId.HPHC]: "PEAK_OFF_PEAK",
}

export function getElectricityProviderCalendar(
    providerCalendarId: ProviderCalendarId
): ElectricityProviderCalendar
export function getElectricityProviderCalendar<TFallback>(
    providerCalendarId: Maybe<string>,
    fallback: TFallback
): ElectricityProviderCalendar | TFallback
export function getElectricityProviderCalendar(
    providerCalendarId: Maybe<string>
): ElectricityProviderCalendar | null

export function getElectricityProviderCalendar<TFallback>(
    providerCalendarId: Maybe<string>,
    fallback?: TFallback
) {
    if (!providerCalendarId) {
        return fallback
    }

    if (isValidProviderCalendarId(providerCalendarId)) {
        return providerCalendarIdMapping[providerCalendarId]
    }

    if (isValidElectricityProviderCalendarId(providerCalendarId)) {
        return providerCalendarId
    }

    return fallback
}
